import React from 'react';
import {Select} from 'antd';
const Option = Select.Option;

 const MultipliersDropdown = (props) => {

  const multipliersChange = (value) => {
    props.multipliersChange(value);
  };

  return (
    <Select size="large" style={{ width: 300 }}
      className="multipliers"
      value={props.multiplier}
      onChange={value => multipliersChange(value)}
      >
      {
        props.multipliers.length === 0 ? 
        (<Option value="Multipliers">Multipliers</Option>) : 
        ( props.multipliers.map((item, index) => {
          return <Option key={index} value={item.origin}>{item.origin}</Option>
        }))
      }
    </Select>
  )
  
}
export default MultipliersDropdown



// WEBPACK FOOTER //
// ./src/components/economicModel/MultipliersDropdown.js